import { ParamsReportEpsEmployee } from './../model/params-report-eps-employee';
import { Injectable, Injector } from '@angular/core';
import { BaseReportService } from '../../shared/_utils/services/base-report-service';
import { LazyLoadEvent } from 'primeng/api';
import { HttpParams } from '@angular/common/http';
import { Vars } from '../model/vars';
import { Observable } from 'rxjs/Observable';
import { map , tap} from 'rxjs/operators';
import { catchError  } from 'rxjs/operators';
import { ReportEpsEmployee } from './../model/report-eps-employee';
import { RemoteWork } from '../model/remote-work';
import { ParamsRemoteWork } from '../model/params-remote-work';

@Injectable()
export class RemoteWorkService extends BaseReportService<RemoteWork> {

  public uri = '/api/remoteWork/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance ReportDeductionsByEmployeeType');
  }

  buildSentence(entity?: RemoteWork, event?: LazyLoadEvent): HttpParams {
    return null;
  }

  searchToViewTable(   params : ParamsRemoteWork
    ): Observable<any> { 
        this.spinnerService.showAll();
        const url = `${this.rutaServidor}${this.uri}search`;
        return this.httpClient.post<any>(url, params )
        .pipe(
          tap(response => { 
            return response;
          },
           error =>{ 
             this.spinnerService.hideAll();
           },
           ()=>{ 
            this.spinnerService.hideAll();
           }
          ), 
          catchError((err) => {
              this.spinnerService.hideAll();
              this.notificationService.serverErrorMessage(err); 
              return new Observable<Blob>();
          })
       );
  } 
}



// WEBPACK FOOTER //
// ./src/app/core/services/remote-work.service.ts